import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import { usePageLang } from '@/hooks/usePageLang';
import { latestArticles, pillarArticles } from '@/mocks/home';

export default function BlogListPage() {
  const { t } = useTranslation('pages');
  const { currentLang } = usePageLang();

  const renderCard = (article: (typeof latestArticles)[number]) => (
    <Link
      key={article.id}
      to={`/${currentLang}/blog/${article.slug}/`}
      className="bg-background-100 rounded-xl p-5 border border-background-200/40 hover:border-primary-300/60 transition-colors group flex flex-col"
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded uppercase tracking-wider">
          {article.category}
        </span>
        <span className="text-foreground-400 text-xs">{article.updated}</span>
      </div>
      <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-700 transition-colors">
        {article.title}
      </h3>
      <p className="text-foreground-600 text-sm leading-relaxed mb-3 flex-1">
        {article.description}
      </p>
      <span className="text-primary-600 text-sm font-medium">{t('blog_read')}</span>
    </Link>
  );

  return (
    <PageShell
      eyebrow={t('blog_eyebrow')}
      title={t('blog_h1')}
      intro={t('blog_intro')}
    >
      <div className="space-y-12">
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-6">
            {t('blog_latest_title')}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {latestArticles.map(renderCard)}
          </div>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-6">
            {t('blog_pillar_title')}
          </h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {pillarArticles.map(renderCard)}
          </div>
        </section>
      </div>
    </PageShell>
  );
}